// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.policy-container {
  margin-bottom: 34px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: var(--dark-gray);
  text-align: center;
}

.policy-container a {
  text-decoration: underline;
}

.policy-container span::before,
.policy-container span::after {
  content: '';
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.policy-link-block.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,WAAW;AACb","sourcesContent":[".policy-container {\n  margin-bottom: 34px;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  color: var(--dark-gray);\n  text-align: center;\n}\n\n.policy-container a {\n  text-decoration: underline;\n}\n\n.policy-container span::before,\n.policy-container span::after {\n  content: '';\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
